export default {
  default: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/layouts/default/Default.vue").then(m => m.default || m)
}